import { SidebarDesktop } from './SidebarDesktop'

export default SidebarDesktop
